<template>
    
    <div class="w-full 
                h-16 
                px-8
                grid 
                grid-cols-20 
                gap-6 
                items-center 
                border-b 
                border-solid 
                border-gray-200
                cursor-pointer
                last:border-b-0
                hover:bg-gray-100"

    @click="selected = !selected"

    >

        <p class="text-sm font-medium tracking-widest col-span-2" >#{{ invoice.number }}</p>

        <p class="text-sm tracking-widest col-span-2" >{{ invoice.clinic }}</p>

        <p class="text-sm tracking-widest col-span-2" >{{ invoice.date }}</p>

        <div class="col-span-2 col-start-15 flex justify-end" >

            <p class="  text-sm
                        w-auto 
                        inline-block 
                        px-3 
                        py-1 
                        rounded-full
                        text-sm
                        text-center 
                        text-white
                        tracking-widest"

                :class="{
                    'bg-teal-500': invoice.isPaid,
                    'bg-yellow-500': !invoice.isPaid 
                }"
            >
            
                {{ invoice.isPaid ? 'PAID' : 'PAY' }}
                
            </p>

        </div>

        <p class="text-sm tracking-widest col-span-2 text-right" >${{ invoice.cost }}</p>

        <div class="col-span-2 flex justify-end" >

            <div 
            
            class="w-6 h-6 bg-gray-200 rounded-full flex items-center justify-center cursor-pointer" 

            :class="{ 'bg-green-500': selected }"
            
            >

                <img src="/images/icons/check-white.svg" alt="check" >

            </div>

        </div>

    </div>

</template>

<script>

    import { ref } from 'vue'

    export default {
    
        name: 'Invoice',

        props: {
            invoice: Object
        },

        setup( props, context ) {

            const selected = ref(false)

            return {
                selected
            }

        }

    }

</script>